import { useMemo } from 'react';

import styles from './styles.module.css';
import {
  createVibrationColumns,
  createTableRows,
  createEngineBearing1Rows,
  createEngineBearing2Rows,
  createEngineBearing3Rows
} from './utils';
import parentStyles from '../../styles.module.css';
import DataTable from '@/components/DataTable';
import EmptyState from '@/components/EmptyState';
import GridContainer from '@/components/GridContainer';
import { getVibrationBearingsPath } from '@/solaris-lens-common-lib/src/utils/turbinesPaths';
const vibrationColumns = createVibrationColumns();

export default function VibrationBearingsTab({
  turbineData
}: {
  turbineData: any;
}) {
  const initialData = useMemo(() => {
    if (turbineData) {
      return getVibrationBearingsPath(turbineData) || {};
    }
    return {};
  }, [turbineData]);

  const tableRows = useMemo(() => createTableRows(initialData), [initialData]);

  const engineBearing1Rows = useMemo(
    () => createEngineBearing1Rows(initialData),
    [initialData]
  );

  const engineBearing2Rows = useMemo(
    () => createEngineBearing2Rows(initialData),
    [initialData]
  );

  const engineBearing3Rows = useMemo(
    () => createEngineBearing3Rows(initialData),
    [initialData]
  );

  const hasData =
    tableRows.length > 0 ||
    engineBearing1Rows.length > 0 ||
    engineBearing2Rows.length > 0 ||
    engineBearing3Rows.length > 0;

  if (!hasData) {
    return (
      <EmptyState
        title="No data available"
        subtitle="No data available for this tab."
      />
    );
  }

  return (
    <GridContainer
      gap="30px"
      className={parentStyles.gridContainerLeft}
      align="none"
    >
      {tableRows.length > 0 && (
        <DataTable
          rows={tableRows}
          columns={vibrationColumns}
          type="detail"
          getRowId={row => row.key}
          noLeftMargin={true}
          alignTextLeft={true}
          className={styles.controlTable}
        />
      )}
      {engineBearing1Rows.length > 0 && (
        <DataTable
          rows={engineBearing1Rows}
          columns={vibrationColumns}
          type="detail"
          getRowId={row => row.key}
          noLeftMargin={true}
          alignTextLeft={true}
          className={styles.controlTable}
        />
      )}
      {engineBearing2Rows.length > 0 && (
        <DataTable
          rows={engineBearing2Rows}
          columns={vibrationColumns}
          type="detail"
          getRowId={row => row.key}
          noLeftMargin={true}
          alignTextLeft={true}
          className={styles.controlTable}
        />
      )}
      {engineBearing3Rows.length > 0 && (
        <DataTable
          rows={engineBearing3Rows}
          columns={vibrationColumns}
          type="detail"
          getRowId={row => row.key}
          noLeftMargin={true}
          alignTextLeft={true}
          className={styles.controlTable}
        />
      )}
    </GridContainer>
  );
}
